export default __webpack_public_path__ + "static/media/strengthBadge.65cb29a2.svg";